export default "__VITE_ASSET__TJ5XwiH1__"